/*
*###############################################################################
*Module Name                   : FirebaseConstants.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Wednesday, October 27th 2021, 12:53:41 pm     #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider } from 'firebase/auth';
//import { getMessaging, getToken} from 'firebase/messaging';


// export const config = {
//     apiKey: "AIzaSyA_fakbmRy7yw-e2m3FgQyC2uAuyufqSrg",
//     authDomain: "mysky-backend.firebaseapp.com",
//     projectId: "mysky-backend",
//     storageBucket: "mysky-backend.appspot.com",
//     messagingSenderId: "322508032561",
//     appId: "1:322508032561:web:77111004be17b941c46310",
//     measurementId: "G-3MHDT3X0L4"
// };

/* export const config = {
    apiKey: "AIzaSyCTpKoyMOwiwk7_D5InxqdAYXkf96-RzJs",
    authDomain: "testcloudmessaging-4b3fe.firebaseapp.com",
    projectId: "testcloudmessaging-4b3fe",
    storageBucket: "testcloudmessaging-4b3fe.appspot.com",
    messagingSenderId: "274354887258",
    appId: "1:274354887258:web:f7231a446bd9c3e7b69663",
    measurementId: "G-FN85VHRXS1"
}; */

export const config = {
    apiKey: "AIzaSyB_vnqYHszvPdDM0Z-QlbEaf4k21FVJ9j4",
    authDomain: "mypos-dynamic.firebaseapp.com",
    projectId: "mypos-dynamic",
    storageBucket: "mypos-dynamic.appspot.com",
    messagingSenderId: "824086732200",
    appId: "1:824086732200:web:753d77143f2291bb93919d",
    measurementId: "G-SQ9GE5L5H2"
};

const app = initializeApp(config);


export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const msProvider = new OAuthProvider('microsoft.com');
export const appleProvider = new OAuthProvider('apple.com')
export const yahooProvider = new OAuthProvider('yahoo.com')
export const twitterProvider = new OAuthProvider('twitter.com')
export const firebaseAuth = getAuth(app);
//const messaging = getMessaging(app);

